export default {
    common: {
        actions: {
            add: 'Dodaj',
            edit: 'Uredi',
            save: 'Shrani',
            cancel: 'Prekliči',
            delete: 'Izbriši',
            close: 'Zapri',
            search: 'Išči',
            filter: 'Filtriraj',
            export: 'Izvozi',
            back: 'Nazaj',
            confirm: 'Potrdi',
            refresh: 'Osveži',
            download: 'Prenesi',
            retry: 'Poskusi znova',
            generate: 'Ustvari',
        },
        labels: {
            date: 'Datum',
            status: 'Status',
            actions: 'Dejanja',
            type: 'Vrsta',
            all: 'Vse',
            total: 'Skupaj',
            name: 'Naziv',
        },
        status: {
            active: 'Aktivno',
            inactive: 'Neaktivno',
            pending: 'V čakanju',
        },
        messages: {
            loading: 'Nalaganje…',
            noData: 'Ni podatkov',
            error: 'Prišlo je do napake',
            success: 'Uspešno',
        },
    },
    settings: {
        title: 'Nastavitve',
        language: 'Jezik',
        languageHint: 'Izberite želeni jezik',
    },
}
